import React, { useEffect, useState } from 'react';
import './styles.css';
import colors from '../../Utils/colors';
import images from '../../Utils/images';
import SidemenuSS from './Components/Sidemenu';
import Setup from './Components/Setup';
import MessageTemplate from './Components/MessageTemplate';
import CustomersData from './Components/CustomersData';
import Flows from './Components/Flows';
import { PremiumOptionModal } from '../../Components/Modal/PremiumOptionModal';
import { useSelector } from 'react-redux';
import WooCommerceAnalytics from './Components/WooCommerceAnalytics';
import { eventsend } from '../../Config/analyticsFunctions';

const WooCommerce = () => {
  const [openSetup, setOpenSetup] = useState(true);
  const [openFlow, setOpenFlow] = useState(false);
  const [selectedMenuItem, setSelectedMenuItem] = useState('Integration');
  const [selectedCampaignFlow, setSelectedCampaignFlow] = useState('');
  const localData = useSelector((state) => state.main.localdata);

  const isPremiumUser = localData?.premium;

  useEffect(()=>{
    eventsend('woocommerce_pageview_web');
  },[])

  return (
    <>
      {!isPremiumUser && (
        <PremiumOptionModal
          option={'WooCommerce'}
          openPremiumModal={true}
          setOpenPremiumModal={() => {}}
        ></PremiumOptionModal>
      )}
      <div className="Row w-100 h-100" style={{}}>
        {/* Shopify Sidemenu */}
        <SidemenuSS
          openSetup={openSetup}
          setOpenSetup={setOpenSetup}
          openFlow={openFlow}
          setOpenFlow={setOpenFlow}
          selectedMenuItem={selectedMenuItem}
          setSelectedMenuItem={setSelectedMenuItem}
        />

        {/* Shopify Body */}
        <div className="Column justify-content-start h-100" style={{ flex: 1 }}>
          {selectedMenuItem == 'Integration' && <Setup setSelectedMenuItem={setSelectedMenuItem} />}
          {selectedMenuItem == 'Message template' && <MessageTemplate />}
          {selectedMenuItem == 'Customers data' && <CustomersData />}
          {/*{selectedMenuItem == 'Abandoned cart' && (*/}
          {/*  <Flows*/}
          {/*    selectedMenuItem={selectedMenuItem}*/}
          {/*    setSelectedMenuItem={setSelectedMenuItem}*/}
          {/*    setSelectedCampaignFlow={setSelectedCampaignFlow}*/}
          {/*  />*/}
          {/*)}*/}
          {selectedMenuItem == 'Order placement' && (
            <Flows
              selectedMenuItem={selectedMenuItem}
              setSelectedMenuItem={setSelectedMenuItem}
              setSelectedCampaignFlow={setSelectedCampaignFlow}
            />
          )}
          {/*{selectedMenuItem == 'Order confirmation' && (*/}
          {/*  <Flows selectedMenuItem={selectedMenuItem} />*/}
          {/*)}*/}
          {selectedMenuItem == 'Analytics' && (
            <WooCommerceAnalytics selectedCampaignFlow={selectedCampaignFlow} />
          )}
        </div>
      </div>
    </>
  );
};

export default WooCommerce;
